const levelCapsByGen = {
  1: [
  { order: "Rivale", name: "Rivale", location: "Route 22", level: 9 },
  { order: 1, name: "Rocko", location: "Marmoria City", level: 14 },
  { order: "Rivale", name: "Rivale", location: "Route 24", level: 18 },
  { order: 2, name: "Misty", location: "Azuria City", level: 21 },
  { order: "Rivale", name: "Rivale", location: "Orania City – MS Anne", level: 20 },
  { order: 3, name: "Lt. Surge", location: "Orania City", level: 24 },
  { order: 4, name: "Erika", location: "Prismania City", level: 29 },
  { order: "Rivale", name: "Rivale", location: "Lavandia", level: 25 },
  { order: 5, name: "Koga", location: "Fuchsania City", level: 43 },
  { order: 6, name: "Sabrina", location: "Saffronia City", level: 50 },
  { order: "Rivale", name: "Rivale", location: "Saffronia City – Silph Co.", level: 40 },
  { order: 7, name: "Pyro", location: "Zinnoberinsel", level: 54 },
  { order: 8, name: "Giovanni", location: "Vertania City", level: 59 },
  { order: "Rivale", name: "Rivale", location: "Route 22", level: 53 },
  { order: "Top 4", name: "Lorelei", location: "Indigo Plateau", level: 54 },
  { order: "Top 4", name: "Bruno", location: "Indigo Plateau", level: 56 },
  { order: "Top 4", name: "Agathe", location: "Indigo Plateau", level: 58 },
  { order: "Top 4", name: "Siegfried", location: "Indigo Plateau", level: 60 },
  { order: "Champ", name: "Rivale", location: "Indigo Plateau", level: 63 },
],
  2: [
  { order: "Rivale", name: "Rivale", location: "Route 29", level: 5 },
  { order: 1, name: "Falk", location: "Viola City", level: 9 },
  { order: "Rivale", name: "Rivale", location: "Azalea City", level: 16 },
  { order: 2, name: "Kai", location: "Azalea City", level: 16 },
  { order: 3, name: "Bianka", location: "Dukatia City", level: 20 },
  { order: "Rivale", name: "Rivale", location: "Prismania City", level: 20 },
  { order: 4, name: "Jasmin", location: "Oliviana City", level: 30 },
  { order: "Rivale", name: "Rivale", location: "Fuchsania City", level: 30 },
  { order: 5, name: "Ampharos", location: "Anemonia City", level: 35 },
  { order: 6, name: "Norbert", location: "Mahagonia City", level: 37 },
  { order: 7, name: "Sandra", location: "Ebenholz City", level: 41 },
  { order: "Top 4", name: "Will", location: "Indigo Plateau", level: 40 },
  { order: "Top 4", name: "Koga", location: "Indigo Plateau", level: 42 },
  { order: "Top 4", name: "Bruno", location: "Indigo Plateau", level: 44 },
  { order: "Top 4", name: "Karin", location: "Indigo Plateau", level: 47 },
  { order: "Champ", name: "Lance", location: "Indigo Plateau", level: 50 },
],
  3: [
  { order: "Rivale", name: "Rivale", location: "Route 103", level: 5 },
  { order: 1, name: "Felizia", location: "Metarost City", level: 14 },
  { order: 2, name: "Kamillo", location: "Faustauhaven", level: 16 },
  { order: "Rivale", name: "Rivale", location: "Route 110", level: 20 },
  { order: 3, name: "Walter", location: "Malvenfroh City", level: 21 },
  { order: 4, name: "Flavia", location: "Laubwechselfeld", level: 28 },
  { order: "Rivale", name: "Rivale", location: "Route 119", level: 31 },
  { order: 5, name: "Norman", location: "Blütenburg City", level: 31 },
  { order: 6, name: "Wibke", location: "Baumhausen City", level: 33 },
  { order: "Rivale", name: "Rivale", location: "Route 120", level: 34 },
  { order: 7, name: "Benedikt & Svenja", location: "Xeneroville", level: 45 },
  { order: "Rivale", name: "Rivale", location: "Vor Pokémon-Liga", level: 42 },
  { order: 8, name: "Juan", location: "Seegrasulb City", level: 48 },
  { order: "Top 4", name: "Ulrich", location: "Pokémon-Liga", level: 50 },
  { order: "Top 4", name: "Antonia", location: "Pokémon-Liga", level: 51 },
  { order: "Top 4", name: "Tobias", location: "Pokémon-Liga", level: 53 },
  { order: "Top 4", name: "Dragan", location: "Pokémon-Liga", level: 55 },
  { order: "Champ", name: "Troy", location: "Pokémon-Liga", level: 58 }
],
  4: [
  { order: "Rivale", name: "Rivale", location: "Route 201", level: 5 },
  { order: 1, name: "Veit", location: "Erzelingen", level: 14 },
  { order: "Rivale", name: "Rivale", location: "Jubelstadt", level: 9 },
  { order: 2, name: "Lamina", location: "Ewigenau", level: 22 },
  { order: "Rivale", name: "Rivale", location: "Elyses", level: 25 },
  { order: 3, name: "Hera", location: "Herzhofen", level: 27 },
  { order: 4, name: "Wahli", location: "Schleiede", level: 30 },
  { order: 5, name: "Theresa", location: "Weideburg", level: 36 },
  { order: "Rivale", name: "Rivale", location: "Blizzach", level: 37 },
  { order: 6, name: "Adam", location: "Blizzach", level: 42 },
  { order: 7, name: "Frida", location: "Sonnewik", level: 47 },
  { order: 8, name: "Volkner", location: "Sonnewik", level: 49 },
  { order: "Rivale", name: "Rivale", location: "Pokémon Liga Eingang", level: 49 },
  { order: "Top 4", name: "Aaron", location: "Pokémon Liga", level: 53 },
  { order: "Top 4", name: "Theresa", location: "Pokémon Liga", level: 55 },
  { order: "Top 4", name: "Ignaz", location: "Pokémon Liga", level: 57 },
  { order: "Top 4", name: "Lucian", location: "Pokémon Liga", level: 59 },
  { order: "Champ", name: "Cynthia", location: "Pokémon Liga", level: 62 },
],
  5: [
  { order: "Rivale", name: "Cheren", location: "Route 1", level: 6 },
  { order: "Rivale", name: "Bell", location: "Blancoria", level: 7 },
  { order: 1, name: "Lilia & Kornelius", location: "Eventura City", level: 13 },
  { order: "Rivale", name: "Cheren", location: "Route 3", level: 14 },
  { order: "Rivale", name: "Bell", location: "Dreamyard", level: 15 },
  { order: 2, name: "Artie", location: "Septerna City", level: 20 },
  { order: "Rivale", name: "Cheren", location: "Wald von Septerna", level: 22 },
  { order: "Rivale", name: "Bell", location: "Septerna City", level: 22 },
  { order: 3, name: "Kamilla", location: "Rayono City", level: 24 },
  { order: "Rivale", name: "Cheren", location: "Route 5", level: 27 },
  { order: "Rivale", name: "Bell", location: "Route 6", level: 29 },
  { order: 4, name: "Sandra", location: "Marea City", level: 30 },
  { order: 5, name: "Turner", location: "Panaero City", level: 35 },
  { order: "Rivale", name: "Cheren", location: "Twist Mountain", level: 36 },
  { order: "Rivale", name: "Bell", location: "Nevaio City", level: 39 },
  { order: 6, name: "Percy", location: "Twist Mountain", level: 39 },
  { order: 7, name: "Viktor", location: "Nevaio City", level: 44 },
  { order: 8, name: "Lauro", location: "Seigaiha City", level: 51 },
  { order: "Rivale", name: "Cheren", location: "Siegesstraße", level: 50 },
  { order: "Top 4", name: "Anissa", location: "Pokémon Liga", level: 52 },
  { order: "Top 4", name: "Astor", location: "Pokémon Liga", level: 54 },
  { order: "Top 4", name: "Kattlea", location: "Pokémon Liga", level: 56 },
  { order: "Top 4", name: "Eugen", location: "Pokémon Liga", level: 58 },
  { order: "Champ", name: "G-Cis", location: "Pokémon Liga", level: 60 }
],
  6: [
  { order: "Rivale", name: "Calem/Serena", location: "Route 2", level: 5 },
  { order: 1, name: "Viola", location: "Nouvaria City", level: 12 },
  { order: "Rivale", name: "Calem/Serena", location: "Illumina City", level: 13 },
  { order: 2, name: "Connie", location: "Reliville", level: 25 },
  { order: "Rivale", name: "Calem/Serena", location: "Route 10", level: 28 },
  { order: 3, name: "Amaro", location: "Yantara City", level: 32 },
  { order: "Rivale", name: "Calem/Serena", location: "Route 11", level: 32 },
  { order: 4, name: "Lilie", location: "Romantia City", level: 34 },
  { order: 5, name: "Valerie", location: "Fluxia City", level: 37 },
  { order: "Rivale", name: "Calem/Serena", location: "Frosthöhle", level: 44 },
  { order: 6, name: "Astrid", location: "Fractalia City", level: 42 },
  { order: "Rivale", name: "Calem/Serena", location: "Illumina City", level: 50 },
  { order: 7, name: "Bastille", location: "Illumina City", level: 48 },
  { order: 8, name: "Dracena", location: "Illumina City", level: 59 },
  { order: "Top 4", name: "Trobato", location: "Pokémon Liga", level: 65 },
  { order: "Top 4", name: "Dracena", location: "Pokémon Liga", level: 65 },
  { order: "Top 4", name: "Thymelot", location: "Pokémon Liga", level: 65 },
  { order: "Top 4", name: "Malva", location: "Pokémon Liga", level: 65 },
  { order: "Champ", name: "Diantha", location: "Pokémon Liga", level: 68 },
  { order: "Extra", name: "Azett", location: "Postgame", level: 65 }

],
  32: [
    { order: "Rivale", name: "Rivale", location: "Route 22", level: 9 },
    { order: 1, name: "Rocko", location: "Marmoria City", level: 14 },
    { order: "Rivale", name: "Rivale", location: "Route 24", level: 18 },
    { order: 2, name: "Misty", location: "Azuria City", level: 21 },
    { order: "Rivale", name: "Rivale", location: "Orania City – MS Anne", level: 20 },
    { order: 3, name: "Lt. Surge", location: "Orania City", level: 24 },
    { order: 4, name: "Erika", location: "Prismania City", level: 29 },
    { order: "Rivale", name: "Rivale", location: "Lavandia (Pokemon Turm)", level: 25 },
    { order: 5, name: "Koga", location: "Fuchsania City", level: 43 },
    { order: 6, name: "Sabrina", location: "Saffronia City", level: 43 },
    { order: "Rivale", name: "Rivale", location: "Saffronia City – Silph Co.", level: 40 },
    { order: 7, name: "Pyro", location: "Zinnoberinsel", level: 47 },
    { order: 8, name: "Giovanni", location: "Vertania City", level: 50 },
    { order: "Rivale", name: "Rivale", location: "Route 22", level: 53 },
    { order: "Top 4", name: "Lorelei", location: "Indigo Plateu", level: 54 },
    { order: "Top 4", name: "Bruno", location: "Indigo Plateu", level: 56 },
    { order: "Top 4", name: "Agathe", location: "Indigo Plateu", level: 58 },
    { order: "Top 4", name: "Siegfried", location: "Indigo Plateu", level: 60 },
    { order: "Champ", name: "Rivale", location: "Indigo Plateu", level: 63 },
  ],
  33: [
    { order: "Rivale", name: "Rivale", location: "Route 103", level: 5 },
    { order: 1, name: "Felizia", location: "Metarost City", level: 14 },
    { order: 2, name: "Kamillo", location: "Faustauhaven", level: 16 },
    { order: "Rivale", name: "Rivale", location: "Route 110", level: 20 },
    { order: 3, name: "Walter", location: "Malvenfroh City", level: 21 },
    { order: 4, name: "Flavia", location: "Bad Lavastadt", level: 28 },
    { order: 5, name: "Norman", location: "Blütenburg City", level: 30 },
    { order: "Rivale", name: "Rivale", location: "Route 119", level: 33 },
    { order: 6, name: "Wibke", location: "Baumhausen City", level: 35 },
    { order: "Rivale", name: "Rivale", location: "Route 120", level: 39 },
    { order: 7, name: "Benedikt & Svenja", location: "Moosbach City", level: 45 },
    { order: 8, name: "Juan", location: "Xeneroville", level: 46 },
    { order: "Rivale", name: "Heiko", location: "Vor Pokémon-Liga", level: 48 },
    { order: "Top 4", name: "Ulrich", location: "Pokémon-Liga", level: 52 },
    { order: "Top 4", name: "Antonia", location: "Pokémon-Liga", level: 53 },
    { order: "Top 4", name: "Tobias", location: "Pokémon-Liga", level: 54 },
    { order: "Top 4", name: "Dragan", location: "Pokémon-Liga", level: 55 },
    { order: "Champ", name: "Troy", location: "Pokémon-Liga", level: 59 },
],

 42: [
  { order: "Rivale", name: "Rivale", location: "Viola City", level: 5 },
  { order: "Knofensa Turm", name: "Boss", location: "Viola City", level: 10 },
  { order: 1, name: "Falk", location: "Viola City", level: 13 },
  { order: "Rivale", name: "Rivale", location: "Azalea City", level: 16 },
  { order: 2, name: "Kai", location: "Azalea City", level: 17 },
  { order: 3, name: "Bianka", location: "Dukatia City", level: 19 },
  { order: 4, name: "Jens", location: "Teak City", level: 25 },
  { order: 5, name: "Hartwig", location: "Anemonia City", level: 31 },
  { order: 6, name: "Jasmin", location: "Oliviana City", level: 35 },
  { order: 7, name: "Norbert", location: "Mahagonia City", level: 34 },
  { order: "Rivale", name: "Rivale", location: "Ebenholz City", level: 36 },
  { order: 8, name: "Sandra", location: "Ebenholz City", level: 41 },
  { order: "Top 4", name: "Will", location: "Indigo Plateau", level: 40 },
  { order: "Top 4", name: "Koga", location: "Indigo Plateau", level: 42 },
  { order: "Top 4", name: "Bruno", location: "Indigo Plateau", level: 44 },
  { order: "Top 4", name: "Karin", location: "Indigo Plateau", level: 47 },
  { order: "Champ", name: "Lance", location: "Indigo Plateau", level: 50 },
  { order: 9, name: "Major Bob", location: "Orania City", level: 53 },
  { order: 10, name: "Sabrina", location: "Saffronia City", level: 55 },
  { order: 11, name: "Erika", location: "Prismania City", level: 56 },
  { order: 12, name: "Misty", location: "Azuria City", level: 54 },
  { order: 13, name: "Janina", location: "Fuchsania City", level: 50 },
  { order: 14, name: "Rocko", location: "Mamoria City", level: 54 },
  { order: 15, name: "Pyro", location: "Seeschauminseln", level: 59 },
  { order: 16, name: "Blau", location: "Vertania City", level: 60 },
  { order: "Finaler Kampf", name: "Rot (Finaler Kampf)", location: "Silberberg", level: 81 },
],

  52: [
  { order: "Rivale", name: "Hugh", location: "Avenitia", level: 5 },
  { order: "Rivale", name: "Hugh", location: "Route 19", level: 8 },
  { order: 1, name: "Cheren", location: "Eventura City", level: 13 },
  { order: "Rivale", name: "Hugh", location: "Floccesy Ranch", level: 13 },
  { order: "Rivale", name: "Hugh", location: "Pokémon Liga Eingang", level: 17 },
  { order: 2, name: "Mica", location: "Septerna City", level: 18 },
  { order: "Rivale", name: "Hugh", location: "Pokéwood", level: 20 },
  { order: 3, name: "Artie", location: "Stratos City", level: 24 },
  { order: 4, name: "Kamilla", location: "Rayono City", level: 30 },
  { order: "Rivale", name: "Hugh", location: "Route 9", level: 33 },
  { order: 5, name: "Turner", location: "Marea City", level: 33 },
  { order: "Rivale", name: "Hugh", location: "Kanalisation", level: 34 },
  { order: 6, name: "Geraldine", location: "Panaero City", level: 39 },
  { order: "Rivale", name: "Hugh", location: "Route 11", level: 41 },
  { order: 7, name: "Lysander", location: "Nevaio City", level: 48 },
  { order: "Rivale", name: "Hugh", location: "Route 22", level: 48 },
  { order: 8, name: "Benson", location: "Seigaiha City", level: 51 },
  { order: "Top 4", name: "Anissa", location: "Pokémon Liga", level: 58 },
  { order: "Top 4", name: "Astor", location: "Pokémon Liga", level: 58 },
  { order: "Top 4", name: "Kattlea", location: "Pokémon Liga", level: 58 },
  { order: "Top 4", name: "Eugen", location: "Pokémon Liga", level: 58 },
  { order: "Champ", name: "Iris", location: "Pokémon Liga", level: 59 }
],
  62: [
  { order: "Rivale", name: "Rivale", location: "Route 103", level: 5 },
  { order: 1, name: "Felizia", location: "Metarost City", level: 14 },
  { order: 2, name: "Kamillo", location: "Faustauhaven", level: 16 },
  { order: "Rivale", name: "Rivale", location: "Route 110", level: 20 },
  { order: 3, name: "Walter", location: "Malvenfroh City", level: 21 },
  { order: 4, name: "Flavia", location: "Bad Lavastadt", level: 28 },
  { order: 5, name: "Norman", location: "Blütenburg City", level: 30 },
  { order: "Rivale", name: "Rivale", location: "Route 119", level: 33 },
  { order: 6, name: "Wibke", location: "Baumhausen City", level: 35 },
  { order: "Rivale", name: "Rivale", location: "Route 120", level: 39 },
  { order: 7, name: "Benedikt & Svenja", location: "Moosbach City", level: 45 },
  { order: 8, name: "Juan", location: "Xeneroville", level: 46 },
  { order: "Rivale", name: "Heiko", location: "Vor Pokémon-Liga", level: 48 },
  { order: "Top 4", name: "Ulrich", location: "Pokémon-Liga", level: 52 },
  { order: "Top 4", name: "Antonia", location: "Pokémon-Liga", level: 53 },
  { order: "Top 4", name: "Tobias", location: "Pokémon-Liga", level: 54 },
  { order: "Top 4", name: "Dragan", location: "Pokémon-Liga", level: 55 },
  { order: "Champ", name: "Troy", location: "Pokémon-Liga", level: 59 }
],

  7: [
  { order: "Rivale", name: "Tali", location: "Hauholi City", level: 6 },
  { order: 1, name: "Ilima (Prüfung)", location: "Verdant Cavern, Mele-Mele", level: 11 },
  { order: 2, name: "Hala (Kahuna)", location: "Iki Town, Mele-Mele", level: 15 },
  { order: "Rivale", name: "Tali", location: "Route 3", level: 17 },
  { order: 3, name: "Lana (Prüfung)", location: "Brooklet Hill, Akala", level: 20 },
  { order: 4, name: "Kiawe (Prüfung)", location: "Wela Volcano Park, Akala", level: 22 },
  { order: 5, name: "Mallow (Prüfung)", location: "Lush Jungle, Akala", level: 24 },
  { order: 6, name: "Mayla (Kahuna)", location: "Konikoni City, Akala", level: 25 },
  { order: "Rivale", name: "Tali", location: "Aether Paradise", level: 31 },
  { order: 7, name: "Sophocles (Prüfung)", location: "Hokulani Observatory, Ula-Ula", level: 33 },
  { order: 8, name: "Acerola (Prüfung)", location: "Thrifty Megamart, Ula-Ula", level: 35 },
  { order: 9, name: "Nanu (Kahuna)", location: "Po Town, Ula-Ula", level: 39 },
  { order: "Rivale", name: "Tali", location: "Mount Lanakila", level: 44 },
  { order: 10, name: "Mina (Prüfung)", location: "Seafolk Village, Poni", level: 45 },
  { order: 11, name: "Hapu'u (Kahuna)", location: "Vast Poni Canyon", level: 48 },
  { order: "Top 4", name: "Hala", location: "Pokémon-Liga", level: 55 },
  { order: "Top 4", name: "Acerola", location: "Pokémon-Liga", level: 56 },
  { order: "Top 4", name: "Kahili", location: "Pokémon-Liga", level: 56 },
  { order: "Top 4", name: "Molayne", location: "Pokémon-Liga", level: 56 },
  { order: "Champ", name: "Kukui", location: "Pokémon-Liga", level: 60 }
],
  72: [
  { order: "Rivale", name: "Tali", location: "Hauholi City", level: 6 },
  { order: 1, name: "Ilima (Prüfung)", location: "Verdant Cavern, Mele-Mele", level: 12 },
  { order: 2, name: "Hala (Kahuna)", location: "Iki Town, Mele-Mele", level: 16 },
  { order: "Rivale", name: "Tali", location: "Route 3", level: 18 },
  { order: 3, name: "Lana (Prüfung)", location: "Brooklet Hill, Akala", level: 20 },
  { order: 4, name: "Kiawe (Prüfung)", location: "Wela Volcano Park, Akala", level: 22 },
  { order: 5, name: "Mallow (Prüfung)", location: "Lush Jungle, Akala", level: 24 },
  { order: 6, name: "Olivia (Kahuna)", location: "Konikoni City, Akala", level: 27 },
  { order: "Rivale", name: "Tali", location: "Aether Paradise", level: 34 },
  { order: 7, name: "Sophocles (Prüfung)", location: "Hokulani Observatory, Ula-Ula", level: 35 },
  { order: 8, name: "Acerola (Prüfung)", location: "Thrifty Megamart, Ula-Ula", level: 36 },
  { order: 9, name: "Valerie (Prüfung)", location: "Ruins of Abundance, Ula-Ula", level: 38 },
  { order: 10, name: "Nanu (Kahuna)", location: "Po Town, Ula-Ula", level: 40 },
  { order: "Rivale", name: "Tali", location: "Mount Lanakila", level: 45 },
  { order: 11, name: "Mina (Prüfung)", location: "Seafolk Village, Poni", level: 47 },
  { order: 12, name: "Hapu'u (Kahuna)", location: "Vast Poni Canyon", level: 48 },
  { order: "Top 4", name: "Kahili", location: "Pokémon-Liga", level: 57 },
  { order: "Top 4", name: "Molayne", location: "Pokémon-Liga", level: 57 },
  { order: "Top 4", name: "Olivia", location: "Pokémon-Liga", level: 58 },
  { order: "Top 4", name: "Acerola", location: "Pokémon-Liga", level: 58 },
  { order: "Champ", name: "Tali", location: "Pokémon-Liga", level: 60 }
],
};

export default levelCapsByGen;